import { createContext, useContext } from 'react';

import { SankeyNode } from '../diagram/types';

export type InteractiveElement = {
  type: 'title' | 'flow' | 'node';
  id?: string;
};

export const isSameInteractiveElement = (
  a?: InteractiveElement,
  b?: InteractiveElement
) => a?.type === b?.type && a?.id === b?.id;

type SankeyInteractionState = {
  focusElement: (element: InteractiveElement) => void;
  blurFocusedElement: () => void;
  handleMouseOver: (element: InteractiveElement) => void;
  handleMouseOut: () => void;
  isDiagramInteractive: boolean;
  isElementFocused: (element: InteractiveElement) => boolean;
  isElementFaded: (element: InteractiveElement) => boolean;
  isElementHighlighted: (element: InteractiveElement) => boolean;
  hintText: string;
  setHintText: (text: string) => void;
  draggedNode: SankeyNode | undefined;
  handleNodeDragStart: (
    ev: React.MouseEvent<SVGElement, MouseEvent>,
    node: SankeyNode
  ) => void;
  handleNodeDragMove: (ev: React.MouseEvent<SVGElement, MouseEvent>) => void;
  handleNodeDragEnd: () => void;
};

export const SankeyInteractionContext = createContext<SankeyInteractionState>({
  focusElement: () => {},
  blurFocusedElement: () => {},
  handleMouseOver: () => {},
  handleMouseOut: () => {},
  isDiagramInteractive: false,
  isElementFocused: () => false,
  isElementFaded: () => false,
  isElementHighlighted: () => false,
  hintText: '',
  setHintText: () => {},
  draggedNode: undefined,
  handleNodeDragStart: () => {},
  handleNodeDragMove: () => {},
  handleNodeDragEnd: () => {},
});

export const useSankeyInteractionContext = () =>
  useContext(SankeyInteractionContext);
